export default __webpack_public_path__ + "static/media/Ice-O-Matic.e7d92b06.svg";